/* global globals */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { withResizeDetector } from 'react-resize-detector/build/withPolyfill';
import ImagesBlockItemMenu from './ImagesBlockItemMenu';
import ImageSvg from './ImageSvg';

const imageSizes = get(globals, 'imageSizes', {});

const getNextSize = (width) => {
  const sizeKeys = Object.keys(imageSizes).reverse();

  let biggestAvailable = null;

  for (let i = 0; i < sizeKeys.length; i += 1) {
    const size = sizeKeys[i];
    if (imageSizes[size].crop) {
      if (imageSizes[size].width > width) {
        return size;
      }

      biggestAvailable = size;
    }
  }

  return biggestAvailable;
};

const ImagesBlockItem = (props) => {
  const {
    hasMenu,
    menuType,
    fileId,
    created,
    memberId,
    gender,
    gcloud,
    likes,
    profile,
    onGalleryOpen,
    width,
  } = props;

  let { filename, size } = props;

  if (width) {
    const realWidth = width * window.devicePixelRatio;
    if (realWidth > imageSizes[size].width) {
      size = getNextSize(realWidth);
    }
  }

  // TODO For now, taken and ajsuted from:
  // 'javascript/src/legacy/flux/components/gallery/GalleryThumb.react.js'
  const targetBasePath = gcloud ? 'gcloudUri' : 'fullStaticImageUri';
  if (gcloud && !filename.includes('jpg')) {
    filename += '.jpg';
  }
  let fullFilename = `${get(globals, targetBasePath, '') + size}/${filename}`;
  let imageHref = `${get(globals, targetBasePath, '')}h/${filename}`;

  // pievieno dzimuma parametru, lai atgrieztu korektu bildi, ja neizdoas ielādēt
  if (gender && !gcloud) {
    fullFilename += `/${gender}`;
    imageHref += `/${gender}`;
  }

  // TODO Looks like this is not necessary, but, for now, can leave it here like this
  // If after some time it still will not be necessary, can simply remove this
  // eslint-disable-next-line
  /* if (filename.match(/\.(jpeg|jpg|gif|png)(?:[\?]+[A-Za-z0-9_.-\/=&-]+)?$/) != null && !gcloud) {
    console.log({
      fullFilename,
      filename,
    });
    fullFilename = filename;
  } */
  //

  const cleanFilename = filename.substr(0, filename.lastIndexOf('.')) || filename;

  const dateString = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleString('lv-LV', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={`imagesThumb${hasMenu ? ' has-menu' : ''}`}>
      <div className="imagesThumb-image">
        <a
          href={imageHref}
          data-file={cleanFilename}
          data-member-id={memberId}
          onClick={(e) => onGalleryOpen(e, cleanFilename)}
        >
          <img src={fullFilename} alt="" />
        </a>
        {hasMenu && (
          <ImagesBlockItemMenu
            menuType={menuType}
            filename={filename}
            fileId={fileId}
            memberId={memberId}
            profile={profile}
          />
        )}
      </div>
      <div className="group">
        <div className="imagesThumb-likes">
          <div className="imagesThumb-likes-icon">
            <ImageSvg svg="icon-heart-2" full />
          </div>
          <div className="imagesThumb-likes-count">
            {likes}
          </div>
        </div>
        {menuType === 'adminMemberImages' && (
          <div className="imagesThumb-likes mls">
            <div className="imagesThumb-likes-icon">
              <ImageSvg svg="icon-calendar" full />
            </div>
            <div className="imagesThumb-likes-count">
              {created && (
                <span>{dateString(created)}</span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

ImagesBlockItem.propTypes = {
  hasMenu: PropTypes.bool,
  menuType: PropTypes.string,
  filename: PropTypes.string,
  fileId: PropTypes.string,
  created: PropTypes.number,
  size: PropTypes.string,
  memberId: PropTypes.string,
  gender: PropTypes.string,
  gcloud: PropTypes.bool,
  likes: PropTypes.number,
  profile: PropTypes.bool,
  onGalleryOpen: PropTypes.func,
  width: PropTypes.number,
};

ImagesBlockItem.defaultProps = {
  hasMenu: false,
  menuType: '',
  filename: '',
  fileId: '',
  created: 0,
  size: 'o-m',
  memberId: '',
  gender: null,
  gcloud: false,
  likes: 0,
  profile: false,
  onGalleryOpen: null,
  width: null,
};

export default withResizeDetector(ImagesBlockItem);
